import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ViewChild, ElementRef } from '@angular/core';
import Cropper from 'cropperjs';
import { UserData, LinkData } from '../../Models/Authentication/UserModel';
import { User } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { ImageUploadService } from '../../Services/image-upload.service';
import { OperationMessageService } from '../../Services/operation-message.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';
import { Camera, CameraPermissionType, CameraResultType, CameraSource } from '@capacitor/camera';
import { ModelService } from '../../Services/model.service';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-account-setting',
  templateUrl: './account-setting.component.html',
  styleUrls: ['./account-setting.component.css'], standalone: false
})
export class AccountSettingComponent extends BaseComponent implements OnInit {
  @ViewChild('imageElement', { static: false }) imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('myModal', { static: false }) modalElement!: ElementRef;
  @ViewChild('imageCanvas', { static: false }) canvasRef!: ElementRef;
  cropper!: Cropper;
  imageUrl: string | ArrayBuffer | null = null;
  croppedImage: string | null = null;
  user!: User
  user1!: UserData
  userId: string;
  form!: FormGroup;
  Links!: FormGroup;
  loading: boolean = false;
  userRole: string = '';
  linksData: LinkData[] = []
  socialLink: LinkData[] = []
  showUpdate: boolean = false
  mess: string = ''
  cropLoad: boolean = false
  constructor
    (

      private auth: AuthService,
      private messageService: MessageService,
      private fb: FormBuilder,
      private api: BaseApiService,
      private imageUploadService: ImageUploadService,
      private translate: OperationMessageService,
      private modelService: ModelService,
      private translate1: TranslateService
    ) {
    super()
    this.userId = this.auth.getUID();
    this.userRole = this.auth.getRoles().toString();

  }

  getdata(uid: any) {
    this.loading = true;
    this.api.read(`Auth/getProfile?uid=${uid}`)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe
      (
        {
          next: (response) => {
            this.user = response;
            if (this.user != null) {
              this.form.patchValue(this.user)
              this.loading = false;
            }
            this.loading = false;
          },
          error: (
            error
          ) => {

            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
          }
        }
      )
  }






  initilizeForm() {
    this.loading = true;
    this.form = this.fb.group({
      id: [''],
      title: [''],
      description: [''],
      image: [this.imageUrl],
      userid: [this.userId],
    });
    this.loading = false;
  }

  initilizeFormLink() {
    this.loading = true;
    this.Links = this.fb.group
      ({
        id: [''],
        userId: [this.userId],
        linkType: [''],
        link: ['', Validators.required],
        linkIcon: ['Social'],
      });
    this.loading = false;
  }
  ngOnInit(): void {
    this.initilizeFormLink();
    this.initilizeForm()
    this.getdata(this.userId);

  }

  onSubmit(): void {
    this.loading = true;
    this.api.update("Auth/UpdateProfile", this.form.value)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe
      (
        {
          next: (response) => {
            this.getdata(this.userId);
            this.cropLoad = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.GetSuccessMessage() });
            this.loading = false;
          }
          ,
          error: (
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
          }
        }
      )
  }

  onFileChanges(event: Event): void {
    this.loading = true;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      // Ensure file is an image (just in case)
      if (file.type.startsWith('image/')) {
        this.upload(file);
      } else {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a valid image.' });
      }
    } else {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select an image' });
    }
  }

  async checkPermissions(): Promise<{ camera: boolean, photos: boolean }> {
    const status = await Camera.checkPermissions();

    const needCamera = status.camera !== 'granted';
    const needPhotos = status.photos !== 'granted' && status.photos !== 'limited';

    let updatedPermissions = { ...status };

    if (needCamera || needPhotos) {
      // Only request the ones that aren't already granted or limited
      const toRequest: CameraPermissionType[] = [];
      if (needCamera) toRequest.push('camera');
      if (needPhotos) toRequest.push('photos');

      const requested = await Camera.requestPermissions({ permissions: toRequest });
      updatedPermissions = { ...updatedPermissions, ...requested };
    }

    return {
      camera: updatedPermissions.camera === 'granted',
      photos: updatedPermissions.photos === 'granted' || updatedPermissions.photos === 'limited',
    };
  }


  // Function to open the app settings page on iOS
  async openSettings() {
    if (Capacitor.getPlatform() === 'ios') {
      // Translate "Open Settings" message based on the current language
      const openSettingsMessage = await this.translate1.get('OPEN_SETTINGS').toPromise();
      // You can either show the translated message in an alert or use it as needed
      alert(openSettingsMessage);

      // Open the settings for your app on iOS
      const appSettingsUrl = 'app-settings:';
      window.open(appSettingsUrl, '_system');
    }
  }
  async openGallery() {
    try {
      const { camera, photos }  = await this.checkPermissions();
      const openSettingsMessage = await this.translate1.get('permission_message').toPromise();
      if (!camera && !photos) {
        const message = openSettingsMessage;

        const userConfirmed = window.confirm(message);
        if (userConfirmed) {
          this.openSettings();
        }
        return;
      }

      let source: CameraSource;

      if (camera && !photos) {
        source = CameraSource.Camera;
      } else if (!camera && photos) {
        source = CameraSource.Photos;
      } else {
        source = CameraSource.Prompt;
      }

      const image = await Camera.getPhoto({
        quality: 90,
        resultType: CameraResultType.Uri,
        source,
        allowEditing: false
      });

      if (image?.webPath) {
        const blob = await fetch(image.webPath).then(res => res.blob());
        const file = new File([blob], 'profile.jpg', { type: blob.type });
        this.upload(file);
      } else {
        this.loading = false;
        //this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No image selected' });
      }
    } catch (error) {
      this.loading = false;
      //this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Image selection failed: ' + error });
    }
  }
  upload(file: any): void {
    this.loading = true
    if (file) {
      this.imageUploadService.uploadImage(file)
        .subscribe
        ((imageUrl: string) => {
          this.imageUrl = imageUrl;
          this.form.get('image')?.setValue(imageUrl);
          this.onSubmit();

        }
          , (error) => {
            {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });

            }
          }
        );
    }
    else {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please select image" });
    }
  }


  imageLoaded = false;
  selectionActive = false;
  image: HTMLImageElement = new Image();

  // Selection box properties
  isSelecting = false;
  startX = 0;
  startY = 0;
  endX = 0;
  endY = 0;

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image.src = e.target?.result as string;
        this.image.onload = () => {
          this.imageLoaded = true;
          this.drawImageOnCanvas();
        };
      };
      reader.readAsDataURL(file);
    }
  }

  drawImageOnCanvas(): void {
    const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(this.image, 0, 0, canvas.width, canvas.height);
    }
  }



  endSelection(): void {
    this.isSelecting = false;
  }

  cropImage(): void {
    const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (!ctx) return;

    // Define crop area
    const cropWidth = this.endX - this.startX;
    const cropHeight = this.endY - this.startY;

    if (cropWidth <= 0 || cropHeight <= 0) return;

    // Create a new canvas for the cropped image
    const croppedCanvas = document.createElement('canvas');
    const croppedCtx = croppedCanvas.getContext('2d');

    croppedCanvas.width = cropWidth;
    croppedCanvas.height = cropHeight;

    if (croppedCtx) {
      croppedCtx.drawImage(canvas, this.startX, this.startY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
      this.croppedImage = croppedCanvas.toDataURL('image/png');

      // Upload or save the cropped image
      this.uploadCroppedImage(this.croppedImage);
    }
  }

  uploadCroppedImage(dataUrl: string): void {
    const blob = this.dataURItoBlob(dataUrl);
    const file = new File([blob], 'cropped_image.png', { type: 'image/png' });
    this.upload(file);
  }

  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }


  startSelection(event: MouseEvent | TouchEvent): void {
    if (!this.imageLoaded) return;
    this.isSelecting = true;
    this.selectionActive = true;

    const { offsetX, offsetY } = this.getEventPosition(event);
    this.startX = offsetX;
    this.startY = offsetY;
  }

  moveSelection(event: MouseEvent | TouchEvent): void {
    if (!this.isSelecting || !this.imageLoaded) return;

    const { offsetX, offsetY } = this.getEventPosition(event);
    this.endX = offsetX;
    this.endY = offsetY;

    const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.drawImageOnCanvas();
      ctx.strokeStyle = 'red';
      ctx.lineWidth = 2;
      ctx.strokeRect(this.startX, this.startY, this.endX - this.startX, this.endY - this.startY);
    }
  }



  // Helper function to get coordinates from MouseEvent or TouchEvent
  getEventPosition(event: MouseEvent | TouchEvent): { offsetX: number; offsetY: number } {
    const canvas = this.canvasRef.nativeElement as HTMLCanvasElement;
    const rect = canvas.getBoundingClientRect();

    if (event instanceof MouseEvent) {
      return {
        offsetX: event.clientX - rect.left,
        offsetY: event.clientY - rect.top,
      };
    } else if (event instanceof TouchEvent) {
      const touch = event.touches[0] || event.changedTouches[0];
      return {
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top,
      };
    }
    return { offsetX: 0, offsetY: 0 };
  }

  closeModal() {
    this.modalElement.nativeElement.classList.remove('show');
    document.body.classList.remove('modal-open');
    document.body.classList.add('hide');
  }



}
